export enum GtmEventType {
  page_view = 'page_view',
  form_start = 'form_start',
  form_submit = 'form_submit',
  form_save = 'form_save',
  body_button_click = 'body_button_click'
}

export class GtmEventBase {
  language : string | null = null
  siteTypeLevel : string | null = null
  event: string | null = null
  form_name: string | null = null
  form_step: string | null = null
}